{
  "el": {
    "overview": {
      "actions": {
        "select_decision": "Επιλογή απόφασης",
        "select_installment": "Επιλογή δόσης",
        "select_point_list": "Επιλογή λίστας παρατηρήσεων",
        "select_survey": "Επιλογή ερωτηματολογίου"
      },
      "table": {
        "labels": {
          "category": "Κατηγορία",
          "level": "Επίπεδο",
          "project": "Έργο",
          "status": "Κατάσταση",
          "unit": "Ακίνητο"
        }
      }
    }
  }
}
